import { render, staticRenderFns } from "./nav-lang.vue?vue&type=template&id=7770fde9&scoped=true"
import script from "./nav-lang.vue?vue&type=script&lang=js"
export * from "./nav-lang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7770fde9",
  null
  
)

export default component.exports